import { useState, useEffect } from 'react';
import WebApp from '@twa-dev/sdk';
import { useTranslation } from 'react-i18next';
import QuickFilters from '../components/home/QuickFilters';
import AssetSearch from '../components/home/AssetSearch';
import TopDeals from '../components/home/TopDeals';
import CardSlider from '../components/CardSlider';
import { useInvestmentOpportunities } from '../hooks/useInvestmentOpportunities';

export default function HomeScreen() {
  const { t } = useTranslation();
  const [activeFilter, setActiveFilter] = useState<string | null>(null);
  const [searchValue, setSearchValue] = useState('');

  const { cards, regularDeals, loading } = useInvestmentOpportunities({
    activeFilter,
    searchValue
  });

  useEffect(() => {
    WebApp.setHeaderColor('secondary_bg_color');
  }, []);

  return (
    <div className="flex flex-col gap-6 max-w-[600px] mx-auto w-full box-border max-[360px]:gap-5">
      <section className="flex flex-col gap-4 w-full max-[360px]:gap-3">
        <AssetSearch 
          searchValue={searchValue}
          onSearchChange={setSearchValue}
          placeholder={t('HOME_SCREEN.SEARCH.PLACEHOLDER')}
        />
      </section>

      <section className="flex flex-col gap-4 w-full max-[360px]:gap-3">
        <div className="flex justify-between items-start gap-4 -mb-0.5 px-0.5">
          <div className="flex flex-col gap-1">
            <h2 className="text-2xl font-bold m-0 text-tg-text max-[360px]:text-xl">
              {t('HOME_SCREEN.QUICK_FILTERS.TITLE')}
            </h2>
            <p className="text-[15px] text-tg-hint m-0 max-[360px]:text-sm">
              {t('HOME_SCREEN.QUICK_FILTERS.CAPTION')}
            </p>
          </div>
        </div>
        <div className="flex flex-col gap-3">
          <QuickFilters 
            activeFilter={activeFilter} 
            onFilterChange={setActiveFilter} 
          />
        </div>
      </section>

      <section className="flex flex-col gap-0 w-full my-0.5 -mb-[60px]">
        <div className="flex justify-between items-start gap-4 -mb-0.5 px-0.5">
          <div className="flex flex-col gap-1">
            <h2 className="text-2xl font-bold m-0 text-tg-text max-[360px]:text-xl">
              {t('HOME_SCREEN.PREMIUM_DEALS.TITLE')}
            </h2>
            <p className="text-[15px] text-tg-hint m-0 max-[360px]:text-sm">
              {t('HOME_SCREEN.PREMIUM_DEALS.CAPTION')}
            </p>
          </div>
        </div>
        <div className="overflow-visible w-screen -ml-[calc(50vw-50%)] -mr-[calc(50vw-50%)]">
          <CardSlider cards={cards} loading={loading} />
        </div>
      </section>

      <section className="flex flex-col gap-4 w-full max-[360px]:gap-3">
        <div className="flex flex-col gap-3">
          <TopDeals 
            opportunities={regularDeals} 
            loading={loading}
          />
        </div>
      </section>
    </div>
  );
}
